export const FlagIconList: Array<{ name: string; prefix: string }> = [];

FlagIconList.push({ name: 'fi-ad', prefix: '' });
FlagIconList.push({ name: 'fi-ae', prefix: '' });
FlagIconList.push({ name: 'fi-af', prefix: '' });
FlagIconList.push({ name: 'fi-ag', prefix: '' });
FlagIconList.push({ name: 'fi-ai', prefix: '' });
FlagIconList.push({ name: 'fi-al', prefix: '' });
FlagIconList.push({ name: 'fi-am', prefix: '' });
//FlagIconList.push({ name: 'fi-an', prefix: '' }); // Netherlands Antilles, no longer exists
FlagIconList.push({ name: 'fi-ao', prefix: '' });
FlagIconList.push({ name: 'fi-aq', prefix: '' });
FlagIconList.push({ name: 'fi-ar', prefix: '' });
FlagIconList.push({ name: 'fi-as', prefix: '' });
FlagIconList.push({ name: 'fi-at', prefix: '' });
FlagIconList.push({ name: 'fi-au', prefix: '' });
FlagIconList.push({ name: 'fi-aw', prefix: '' });
FlagIconList.push({ name: 'fi-ax', prefix: '' });
FlagIconList.push({ name: 'fi-az', prefix: '' });
FlagIconList.push({ name: 'fi-ba', prefix: '' });
FlagIconList.push({ name: 'fi-bb', prefix: '' });
FlagIconList.push({ name: 'fi-bd', prefix: '' });
FlagIconList.push({ name: 'fi-be', prefix: '' });
FlagIconList.push({ name: 'fi-bf', prefix: '' });
FlagIconList.push({ name: 'fi-bg', prefix: '' });
FlagIconList.push({ name: 'fi-bh', prefix: '' });
FlagIconList.push({ name: 'fi-bi', prefix: '' });
FlagIconList.push({ name: 'fi-bj', prefix: '' });
FlagIconList.push({ name: 'fi-bm', prefix: '' });
FlagIconList.push({ name: 'fi-bn', prefix: '' });
FlagIconList.push({ name: 'fi-bo', prefix: '' });
FlagIconList.push({ name: 'fi-br', prefix: '' });
FlagIconList.push({ name: 'fi-bs', prefix: '' });
FlagIconList.push({ name: 'fi-bt', prefix: '' });
FlagIconList.push({ name: 'fi-bv', prefix: '' });
FlagIconList.push({ name: 'fi-bw', prefix: '' });
FlagIconList.push({ name: 'fi-by', prefix: '' });
FlagIconList.push({ name: 'fi-bz', prefix: '' });
FlagIconList.push({ name: 'fi-ca', prefix: '' });
FlagIconList.push({ name: 'fi-cc', prefix: '' });
FlagIconList.push({ name: 'fi-cd', prefix: '' });
FlagIconList.push({ name: 'fi-cf', prefix: '' });
FlagIconList.push({ name: 'fi-cg', prefix: '' });
FlagIconList.push({ name: 'fi-ch', prefix: '' });
FlagIconList.push({ name: 'fi-ci', prefix: '' });
FlagIconList.push({ name: 'fi-ck', prefix: '' });
FlagIconList.push({ name: 'fi-cl', prefix: '' });
FlagIconList.push({ name: 'fi-cm', prefix: '' });
FlagIconList.push({ name: 'fi-cn', prefix: '' });
FlagIconList.push({ name: 'fi-co', prefix: '' });
FlagIconList.push({ name: 'fi-cr', prefix: '' });
FlagIconList.push({ name: 'fi-cs', prefix: '' });
FlagIconList.push({ name: 'fi-cu', prefix: '' });
FlagIconList.push({ name: 'fi-cv', prefix: '' });
FlagIconList.push({ name: 'fi-cx', prefix: '' });
FlagIconList.push({ name: 'fi-cy', prefix: '' });
FlagIconList.push({ name: 'fi-cz', prefix: '' });
FlagIconList.push({ name: 'fi-de', prefix: '' });
FlagIconList.push({ name: 'fi-dj', prefix: '' });
FlagIconList.push({ name: 'fi-dk', prefix: '' });
FlagIconList.push({ name: 'fi-dm', prefix: '' });
FlagIconList.push({ name: 'fi-do', prefix: '' });
FlagIconList.push({ name: 'fi-dz', prefix: '' });
FlagIconList.push({ name: 'fi-ec', prefix: '' });
FlagIconList.push({ name: 'fi-ee', prefix: '' });
FlagIconList.push({ name: 'fi-eg', prefix: '' });
FlagIconList.push({ name: 'fi-eh', prefix: '' });
FlagIconList.push({ name: 'fi-er', prefix: '' });
FlagIconList.push({ name: 'fi-es', prefix: '' });
FlagIconList.push({ name: 'fi-et', prefix: '' });
FlagIconList.push({ name: 'fi-fi', prefix: '' });
FlagIconList.push({ name: 'fi-fj', prefix: '' });
FlagIconList.push({ name: 'fi-fk', prefix: '' });
FlagIconList.push({ name: 'fi-fm', prefix: '' });
FlagIconList.push({ name: 'fi-fo', prefix: '' });
FlagIconList.push({ name: 'fi-fr', prefix: '' });
FlagIconList.push({ name: 'fi-ga', prefix: '' });
FlagIconList.push({ name: 'fi-gb', prefix: '' });
FlagIconList.push({ name: 'fi-gd', prefix: '' });
FlagIconList.push({ name: 'fi-ge', prefix: '' });
FlagIconList.push({ name: 'fi-gf', prefix: '' });
FlagIconList.push({ name: 'fi-gh', prefix: '' });
FlagIconList.push({ name: 'fi-gi', prefix: '' });
FlagIconList.push({ name: 'fi-gl', prefix: '' });
FlagIconList.push({ name: 'fi-gm', prefix: '' });
FlagIconList.push({ name: 'fi-gn', prefix: '' });
FlagIconList.push({ name: 'fi-gp', prefix: '' });
FlagIconList.push({ name: 'fi-gq', prefix: '' });
FlagIconList.push({ name: 'fi-gr', prefix: '' });
FlagIconList.push({ name: 'fi-gs', prefix: '' });
FlagIconList.push({ name: 'fi-gt', prefix: '' });
FlagIconList.push({ name: 'fi-gu', prefix: '' });
FlagIconList.push({ name: 'fi-gw', prefix: '' });
FlagIconList.push({ name: 'fi-gy', prefix: '' });
FlagIconList.push({ name: 'fi-hk', prefix: '' });
FlagIconList.push({ name: 'fi-hm', prefix: '' });
FlagIconList.push({ name: 'fi-hn', prefix: '' });
FlagIconList.push({ name: 'fi-hr', prefix: '' });
FlagIconList.push({ name: 'fi-ht', prefix: '' });
FlagIconList.push({ name: 'fi-hu', prefix: '' });
FlagIconList.push({ name: 'fi-id', prefix: '' });
FlagIconList.push({ name: 'fi-ie', prefix: '' });
FlagIconList.push({ name: 'fi-il', prefix: '' });
FlagIconList.push({ name: 'fi-in', prefix: '' });
FlagIconList.push({ name: 'fi-io', prefix: '' });
FlagIconList.push({ name: 'fi-iq', prefix: '' });
FlagIconList.push({ name: 'fi-ir', prefix: '' });
FlagIconList.push({ name: 'fi-is', prefix: '' });
FlagIconList.push({ name: 'fi-it', prefix: '' });
FlagIconList.push({ name: 'fi-jm', prefix: '' });
FlagIconList.push({ name: 'fi-jo', prefix: '' });
FlagIconList.push({ name: 'fi-jp', prefix: '' });
FlagIconList.push({ name: 'fi-ke', prefix: '' });
FlagIconList.push({ name: 'fi-kg', prefix: '' });
FlagIconList.push({ name: 'fi-kh', prefix: '' });
FlagIconList.push({ name: 'fi-ki', prefix: '' });
FlagIconList.push({ name: 'fi-km', prefix: '' });
FlagIconList.push({ name: 'fi-kn', prefix: '' });
FlagIconList.push({ name: 'fi-kp', prefix: '' });
FlagIconList.push({ name: 'fi-kr', prefix: '' });
FlagIconList.push({ name: 'fi-kw', prefix: '' });
FlagIconList.push({ name: 'fi-ky', prefix: '' });
FlagIconList.push({ name: 'fi-kz', prefix: '' });
FlagIconList.push({ name: 'fi-la', prefix: '' });
FlagIconList.push({ name: 'fi-lb', prefix: '' });
FlagIconList.push({ name: 'fi-lc', prefix: '' });
FlagIconList.push({ name: 'fi-li', prefix: '' });
FlagIconList.push({ name: 'fi-lk', prefix: '' });
FlagIconList.push({ name: 'fi-lr', prefix: '' });
FlagIconList.push({ name: 'fi-ls', prefix: '' });
FlagIconList.push({ name: 'fi-lt', prefix: '' });
FlagIconList.push({ name: 'fi-lu', prefix: '' });
FlagIconList.push({ name: 'fi-lv', prefix: '' });
FlagIconList.push({ name: 'fi-ly', prefix: '' });
FlagIconList.push({ name: 'fi-ma', prefix: '' });
FlagIconList.push({ name: 'fi-mc', prefix: '' });
FlagIconList.push({ name: 'fi-md', prefix: '' });
FlagIconList.push({ name: 'fi-me', prefix: '' });
FlagIconList.push({ name: 'fi-mg', prefix: '' });
FlagIconList.push({ name: 'fi-mh', prefix: '' });
FlagIconList.push({ name: 'fi-mk', prefix: '' });
FlagIconList.push({ name: 'fi-ml', prefix: '' });
FlagIconList.push({ name: 'fi-mm', prefix: '' });
FlagIconList.push({ name: 'fi-mn', prefix: '' });
FlagIconList.push({ name: 'fi-mo', prefix: '' });
FlagIconList.push({ name: 'fi-mp', prefix: '' });
FlagIconList.push({ name: 'fi-mq', prefix: '' });
FlagIconList.push({ name: 'fi-mr', prefix: '' });
FlagIconList.push({ name: 'fi-ms', prefix: '' });
FlagIconList.push({ name: 'fi-mt', prefix: '' });
FlagIconList.push({ name: 'fi-mu', prefix: '' });
FlagIconList.push({ name: 'fi-mv', prefix: '' });
FlagIconList.push({ name: 'fi-mw', prefix: '' });
FlagIconList.push({ name: 'fi-mx', prefix: '' });
FlagIconList.push({ name: 'fi-my', prefix: '' });
FlagIconList.push({ name: 'fi-mz', prefix: '' });
FlagIconList.push({ name: 'fi-na', prefix: '' });
FlagIconList.push({ name: 'fi-nc', prefix: '' });
FlagIconList.push({ name: 'fi-ne', prefix: '' });
FlagIconList.push({ name: 'fi-nf', prefix: '' });
FlagIconList.push({ name: 'fi-ng', prefix: '' });
FlagIconList.push({ name: 'fi-ni', prefix: '' });
FlagIconList.push({ name: 'fi-nl', prefix: '' });
FlagIconList.push({ name: 'fi-nn', prefix: '' }); // No nation, used for stateless flags
FlagIconList.push({ name: 'fi-no', prefix: '' });
FlagIconList.push({ name: 'fi-np', prefix: '' });
FlagIconList.push({ name: 'fi-nr', prefix: '' });
FlagIconList.push({ name: 'fi-nu', prefix: '' });
FlagIconList.push({ name: 'fi-nz', prefix: '' });
FlagIconList.push({ name: 'fi-om', prefix: '' });
FlagIconList.push({ name: 'fi-pa', prefix: '' });
FlagIconList.push({ name: 'fi-pe', prefix: '' });
FlagIconList.push({ name: 'fi-pf', prefix: '' });
FlagIconList.push({ name: 'fi-pg', prefix: '' });
FlagIconList.push({ name: 'fi-ph', prefix: '' });
FlagIconList.push({ name: 'fi-pk', prefix: '' });
FlagIconList.push({ name: 'fi-pl', prefix: '' });
FlagIconList.push({ name: 'fi-pm', prefix: '' });
FlagIconList.push({ name: 'fi-pn', prefix: '' });
FlagIconList.push({ name: 'fi-pr', prefix: '' });
FlagIconList.push({ name: 'fi-ps', prefix: '' });
FlagIconList.push({ name: 'fi-pt', prefix: '' });
FlagIconList.push({ name: 'fi-pw', prefix: '' });
FlagIconList.push({ name: 'fi-py', prefix: '' });
FlagIconList.push({ name: 'fi-qa', prefix: '' });
FlagIconList.push({ name: 'fi-re', prefix: '' });
FlagIconList.push({ name: 'fi-ro', prefix: '' });
FlagIconList.push({ name: 'fi-rs', prefix: '' });
FlagIconList.push({ name: 'fi-ru', prefix: '' });
FlagIconList.push({ name: 'fi-rw', prefix: '' });
FlagIconList.push({ name: 'fi-sa', prefix: '' });
FlagIconList.push({ name: 'fi-sb', prefix: '' });
FlagIconList.push({ name: 'fi-sc', prefix: '' });
FlagIconList.push({ name: 'fi-sd', prefix: '' });
FlagIconList.push({ name: 'fi-se', prefix: '' });
FlagIconList.push({ name: 'fi-sg', prefix: '' });
FlagIconList.push({ name: 'fi-sh', prefix: '' });
FlagIconList.push({ name: 'fi-si', prefix: '' });
FlagIconList.push({ name: 'fi-sj', prefix: '' });
FlagIconList.push({ name: 'fi-sk', prefix: '' });
FlagIconList.push({ name: 'fi-sl', prefix: '' });
FlagIconList.push({ name: 'fi-sm', prefix: '' });
FlagIconList.push({ name: 'fi-sn', prefix: '' });
FlagIconList.push({ name: 'fi-so', prefix: '' });
FlagIconList.push({ name: 'fi-sr', prefix: '' });
FlagIconList.push({ name: 'fi-st', prefix: '' });
FlagIconList.push({ name: 'fi-sv', prefix: '' });
FlagIconList.push({ name: 'fi-sy', prefix: '' });
FlagIconList.push({ name: 'fi-sz', prefix: '' });
FlagIconList.push({ name: 'fi-tc', prefix: '' });
FlagIconList.push({ name: 'fi-td', prefix: '' });
FlagIconList.push({ name: 'fi-tf', prefix: '' });
FlagIconList.push({ name: 'fi-tg', prefix: '' });
FlagIconList.push({ name: 'fi-th', prefix: '' });
FlagIconList.push({ name: 'fi-tj', prefix: '' });
FlagIconList.push({ name: 'fi-tk', prefix: '' });
FlagIconList.push({ name: 'fi-tl', prefix: '' });
FlagIconList.push({ name: 'fi-tm', prefix: '' });
FlagIconList.push({ name: 'fi-tn', prefix: '' });
FlagIconList.push({ name: 'fi-to', prefix: '' });
FlagIconList.push({ name: 'fi-tr', prefix: '' });
FlagIconList.push({ name: 'fi-tt', prefix: '' });
FlagIconList.push({ name: 'fi-tv', prefix: '' });
FlagIconList.push({ name: 'fi-tw', prefix: '' });
FlagIconList.push({ name: 'fi-tz', prefix: '' });
FlagIconList.push({ name: 'fi-ua', prefix: '' });
FlagIconList.push({ name: 'fi-ug', prefix: '' });
FlagIconList.push({ name: 'fi-um', prefix: '' });
FlagIconList.push({ name: 'fi-us', prefix: '' });
FlagIconList.push({ name: 'fi-uy', prefix: '' });
FlagIconList.push({ name: 'fi-uz', prefix: '' });
FlagIconList.push({ name: 'fi-va', prefix: '' });
FlagIconList.push({ name: 'fi-vc', prefix: '' });
FlagIconList.push({ name: 'fi-ve', prefix: '' });
FlagIconList.push({ name: 'fi-vg', prefix: '' });
FlagIconList.push({ name: 'fi-vi', prefix: '' });
FlagIconList.push({ name: 'fi-vn', prefix: '' });
FlagIconList.push({ name: 'fi-vu', prefix: '' });
FlagIconList.push({ name: 'fi-wf', prefix: '' });
FlagIconList.push({ name: 'fi-ws', prefix: '' });
FlagIconList.push({ name: 'fi-ye', prefix: '' });
FlagIconList.push({ name: 'fi-yt', prefix: '' });
FlagIconList.push({ name: 'fi-za', prefix: '' });
FlagIconList.push({ name: 'fi-zm', prefix: '' });
FlagIconList.push({ name: 'fi-zw', prefix: '' });
FlagIconList.push({ name: 'fi-rf', prefix: '' }); // Refugee Olympic Team
